// import Colors from '../../../Configs/colors';

const styles = {
  root: {
    padding: '16px 0',
  },
};

export default styles;
